import { apiService } from "api/apiService";
import type {
  FilterResource,
  TeacherPortfolioTaskShallowResource,
} from "api/generated";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import { teacherScheduledTaskFromDto } from "portfolio/api/mappers";
import type { TeacherScheduledTask } from "portfolio/types";
import { mapFilters } from "shared/mappers";
import type { Filter } from "shared/types";

export const fetchMentorClassTasks = async (
  mentorClass: string,
  params: Record<string, string> = {},
): Promise<PaginatedResult<TeacherScheduledTask>> => {
  const { data } = await apiService.get<
    PaginatedResponse<TeacherPortfolioTaskShallowResource>
  >(`api/my-students/${encodeURIComponent(mentorClass)}/portfolio-tasks`, {
    params,
  });

  return mapPaginatedResponse(data, teacherScheduledTaskFromDto);
};

export const fetchMentorClassTaskFilters = async (
  mentorClass: string,
): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/my-students/${encodeURIComponent(mentorClass)}/portfolio-tasks/filters`,
  );

  return mapFilters(filters);
};
